import { useTransactionsAndFaos } from "../../../Context/crm/TransactionsAndFaosContext"
import { Badge, Box, Chip, Link } from "@mui/material"
import Transaction from '../../../assets/Images/icons/enQt.svg'
import CustomBtn from "../../customBtns/CustomBtn"
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';

const TransactionsBadge = ({onClick}) => {
    const {transactions} = useTransactionsAndFaos()

    return (
        <Box sx={{marginRight: "15px"}}>
          <Link to="#transaction" onClick={onClick} sx={{cursor: "pointer" , marginInline: {xl : 0, lg: 0, md: 0 , sm: 0 ,xs:1}}}>
            <Badge
                sx={{
                    "& .MuiBadge-badge": {
                        background: "#CEDEF2",
                        color: "#000000",
                    }
                }}
                badgeContent={transactions.length > 0 ? transactions.length : '0'}
                color="error" size="small"
                anchorOrigin={{  vertical: 'top', horizontal: 'left', }}>
            <CustomBtn
                          bgColor={"#CEDEF2"}
                          label="Transactions"
                          iconBg={"#CEDEF2"}
                          textColor={"#000000"}
                          style={{
                              transition: 'background-color 0.4s ease, color 0.4s ease',
                              '&:hover': {
                                  backgroundColor: '#000000 !important',
                                  color: '#ffffff !important',
                              },
                              '&:hover .MuiChip-label': {
                                  color: '#ffffff',
                              },
                              '&:hover .MuiAvatar-root': {
                                  backgroundColor: '#000000 !important',
                              },
                              '&:hover svg': {
                                  color: '#ffffff !important',
                              }
                          }}
                          icon={<PaidOutlinedIcon sx={{ fontSize: "18px", color:"#000000" }} />}
                      />
            </Badge>
          </Link>
        </Box>
    )
}

export default TransactionsBadge